import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { ItemType } from './types';

interface Props {
  show: boolean;
  onHide: () => void;
  itemType: ItemType | null;
  onViewChecklist?: (id: number) => void;
}

const ViewItemTypeModal: React.FC<Props> = ({ show, onHide, itemType, onViewChecklist }) => {
  if (!itemType) return null;

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Item Type Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <strong>ID:</strong> {itemType.id}
        </div>
        <div className="mb-3">
          <strong>Name:</strong> {itemType.itemType}
        </div>
        <div className="mb-3">
          <strong>Description:</strong> {itemType.description}
        </div>
        <div className="mb-3">
          <strong>Checklist Template:</strong>{' '}
          {itemType.checklistTemplate ? (
            <span className="badge bg-success">Template set</span>
          ) : (
            <span className="badge bg-secondary">No template</span>
          )}
        </div>

      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ViewItemTypeModal;